import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ServiceModel } from './model';

export const adapter: EntityAdapter<ServiceModel> = createEntityAdapter<ServiceModel>({
  selectId: model => model.id,
});

export interface ServiceCatalogState extends EntityState<ServiceModel> {
  filtered: ServiceModel[];
  selected: ServiceModel;
  isLoading?: boolean;
  error?: any;
}

export const initialState: ServiceCatalogState = adapter.getInitialState({
  filtered: null,
  selected: null,
  isLoading: false,
  error: null,
});
